<template>
  <div v-if="!getStore().statsError && (!isEmptyObject(getStats()) || isContractorCo() || isLandlordCo() || isBackhaulCo())">
        <el-menu
        v-if="this.loggedIn()"
        :router="true"
        v-model="index"
        mode="horizontal"
        background-color="#2f3e57"
        text-color="#fff"
        active-text-color="#ffd04b">

        <el-menu-item index="home" :route="{path: this.loggedIn() ? '/' : ''}">
          <template slot="title">
            <img class="nav-logo" style="height: 2.5em;"
            :src="'../' + logo" :alt="clientName">
          </template>
        </el-menu-item>

        <template v-for="(item, index) in menu">
          <el-menu-item
          v-if="item.visible"
          :index="item.key" :route="{path: item.path}">
          <i :class="item.icon">&nbsp;</i>{{isDesktop ? item.title : '' }}
        </el-menu-item>
      </template>


      <el-submenu index="99" style="float: right;" v-if="this.loggedIn()">
        <template slot="title">
          <i class="fa fa-user"></i>
          <span slot="title">{{isDesktop ? this.profile().login : ''}}</span>
        </template>
        <el-menu-item-group title="">
          <el-menu-item index="7-1" :route="{path: '/profile'}"><i class=""></i> User Profile</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="">
          <el-menu-item index="7-2" v-if="isManager()" :route="{path: '/settings'}"><i class="fa fa-cog"></i> Settings</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="">
          <el-menu-item index="7-3" :route="{path: '/logout'}"><i class="fa fa-power-off"></i> Logout</el-menu-item>
        </el-menu-item-group>


        <el-menu-item-group title="About..">
          <el-menu-item index="7-4" :route="{path: '/about'}"><i class="fa fa-info"></i> About</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

    </el-menu>

    <el-container>

      <el-main>
        <transition name="fade">
          <router-view></router-view>
        </transition>

      </el-main>

    </el-container>
  </div>
  <div v-else-if="getStore().statsError">
    <center>
      <br>
      <br>
      <br>
      <i class="fa fa-exclamation-triangle fa-2x text-warning"></i>
      <br>
      <br>
      <h3>Server Side Unknown Error</h3>
      <p>We are sorry but our server encountered an internal error.</p>
      <p>Please try again later.</p>
      <br>
      <p>If the issue persists, please contact support.</p>
      <br>
      <el-button @click="refreshBrowser()">Reload</el-button>
    </center>
  </div>
  <div v-else>
      <center><i class="fa fa-spinner fa-2x fa-spin text-primary"></i></center>
  </div>
</template>

<script>

export default {

  methods: {
    canView (menu) {
      let category = this.org().category

      switch (category) {
          case 'Backhaul': return this.backhaulMenu(menu)
          case 'Contractor': return this.contractorMenu(menu)
          case 'Landlord': return this.landlordMenu(menu)
          case 'Telco': return this.telcoMenu(menu)
          case 'Tower Supplier': return this.towerSupplierMenu(menu)
          default: return this.towerMenu(menu)
      }

    },

    backhaulMenu (menu) {

      switch (menu) {
          case 'dashboard': return false
          case 'sites': return true
          case 'requests': return true
          case 'map': return true
          case 'tickets': return true
          case 'help': return false
          default: return false
      }

    },

    contractorMenu (menu) {

      switch (menu) {
          case 'dashboard': return false
          case 'sites': return true
          case 'requests': return false
          case 'map': return true
          case 'tickets': return true
          case 'help': return false
          default: return false
      }

    },

    landlordMenu (menu) {

      switch (menu) {
          case 'dashboard': return false
          case 'sites': return true
          case 'requests': return false
          case 'map': return true
          case 'tickets': return false
          case 'help': return false
          default: return false
      }

    },

    telcoMenu (menu) {
      return true
    },

    towerMenu (menu) {
      switch (menu) {
          case 'dashboard': return true
          case 'sites': return true
          case 'requests': return this.canAccess('project|maintenance|finance|admin|management')
          case 'map': return true
          case 'tickets': return this.canAccess('project|maintenance|admin|management')
          case 'help': return true
          default: return false
      }

    },

    towerSupplierMenu (menu) {

      switch (menu) {
          case 'dashboard': return false
          case 'sites': return true
          case 'requests': return false
          case 'map': return true
          case 'tickets': return true
          case 'help': return false
          default: return false
      }

    },


  },

  data () {
    return {
      index: 'home',
      logo: this.xolasClient().logoPath,
      clientName: this.xolasClient().name,
      menu: [
        {
          key: 'dashboard',
          title: 'Dashboard',
          icon: 'fa fa-tachometer-alt',
          path: '/',
          visible: this.canView('dashboard')
        },
        {
          key: 'sites',
          title: 'Sites',
          icon: 'fa fa-broadcast-tower',
          path: '/sites',
          visible: this.canView('sites')
        },
        {
          key: 'requests',
          title: 'Requests',
          icon: 'fa fa-share-alt',
          path: '/requests',
          visible: this.canView('requests')
        },
        {
          key: 'map',
          title: 'Map',
          icon: 'fa fa-map',
          path: '/map',
          visible: this.canView('map')
        },
        {
          key: 'tickets',
          title: 'Tickets',
          icon: 'fa fa-headset',
          path: '/tickets',
          visible: this.canView('tickets')
        },
        {
          key: 'help',
          title: 'Help',
          icon: 'fa fa-question',
          path: '/help',
          visible: this.canView('help')
        }
      ]
    }
  },

  created () {
//   console.log('access: ', this.getStats(), !this.isEmptyObject(this.getStats()), this.isContractorCo(), this.isLandlordCo(), this.isBackhaulCo())
  }

}
</script>



// WEBPACK FOOTER //
// Home.vue?548cea51